<template>
    <section :class="`accordion accordion-${displayType}`">
        <div class="inner">
            <h2 v-if="title && !cardsDisplay" class="h2">{{ title }}</h2>
            <BlocksCLAccordionCards
                v-if="cardsDisplay"
                :title="title"
                :cards="cards"
                :is-open="display?.firstOpen === 'true'"
            />
            <BlocksCLAccordionDefault v-else :cards="cards" :first-open="display?.firstOpen === 'true'" />
        </div>
    </section>
</template>
<script setup>
import { computed } from 'vue';

const props = defineProps({
    type: {
        type: [ String, null ],
        required: false,
        default: 'accordion',
    },
    internal: {
        type: [ String, null ],
        required: false,
        default: 'Accordion Title',
    },
    display: {
        type: Object,
        required: false,
        default: () => ({
            component: 'accordion',
        }),
    },
    title: {
        type: [ String, null ],
        required: false,
        default: '',
    },
    cards: {
        type: [ Array ],
        required: false,
        default: () => [],
    },
});
const displayType = computed(() => props.display.displayType ?? 'default');
const cardsDisplay = computed(() => displayType.value === 'cards');
</script>
<style scoped>
.accordion {
  display: grid;
  max-width: var(--desktop-max-width);
  width: 100%;
  margin: 0 auto;
}
.accordion .inner {
  max-width: var(--page-max-width);
  margin: 0 auto;
  padding-left: 1.5rem;
  width: 100%;
  padding-right: 1.5rem;
}
.accordion {
  padding-top: 4rem;
  padding-bottom: 4rem;
  will-change: height;
}

*:not(.accordion-cards) + .accordion-cards:has(+ .accordion-cards) {
  padding-top: 4rem;
}

.accordion-cards:has(+ .accordion-cards) {
  padding-top: 0;
  padding-bottom: 0;
}
.accordion-cards:has(+ .accordion-cards) .inner {
  border-bottom: 2px solid var(--color-base-grey-300);
}
.accordion-cards:has(+ .accordion-cards) + .accordion-cards {
  padding-top: 0;
}
</style>
